module.exports = __webpack_public_path__ + "static/image2-754ee96c6301649a36e27fb0b08aa641.jpg";